import React from 'react';

import { useGetSettings } from 'src/features/administration/api/useGetSettings';
import SettingsContext from 'src/features/administration/context/SettingsContext';
import { Settings } from 'src/features/administration/utils/types';
import AuthContext from 'src/features/auth/context/AuthContext';
import { useParking } from 'src/providers/ParkingProvider';
import { LOCALE } from 'src/providers/types';
import { storage } from 'src/registry/utils/storage';
import { CURRENCY } from 'src/types';

const defaultSettings: Settings = {
    languages: [LOCALE.EN, LOCALE.BG],
    default_language: 'en',
    default_currency: CURRENCY.EUR,
};

function SettingsProvider({ children }: { children: React.ReactNode }) {
    const { user, permissionsLoaded } = React.useContext(AuthContext);
    const { parkingId } = useParking();
    const { data: settings } = useGetSettings({ parkingId, config: { enabled: !!user && permissionsLoaded } });

    React.useEffect(() => {
        if (!storage.getLanguage()) {
            storage.setLanguage(settings?.default_language || defaultSettings.default_language);
        }
    }, [settings]);

    return <SettingsContext.Provider value={settings || defaultSettings}>{children}</SettingsContext.Provider>;
}

export { SettingsProvider };
